// removed by extract-text-webpack-plugin
module.exports = {"baseButton":"dFsu8t","primary":"_2CdOjN","disabled":"_3M8_Pt","flat":"_3-IJkM","transparent":"W6-B_Q","secondary":"_336sNf","reverse":"_25-xYg","alignLeft":"_2jjwP7","loading":"Uc-tF1","underline":"NRlf1h","with-icon":"m5re8i","withIcon":"m5re8i","fullWidth":"_3CrCss","expands":"_202cZS _3CrCss","small":"_2WR6ZP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseButton/baseButton-style.css
// module id = 256
// module chunks = 0